import React from "react";
import { formatFechaNacimiento } from "../../utils/postulacionHelpers";

interface ParticipanteCardProps {
  readonly participante: any;
  readonly index: number;
  readonly firmasParticipantes: { [key: number]: string };
}

export function ParticipanteCard({ participante, index, firmasParticipantes }: ParticipanteCardProps) {
  const fechaNacimiento = formatFechaNacimiento(participante.fechaNacimiento);
  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: "8px",
        marginBottom: "10px",
        borderRadius: "4px",
        backgroundColor: "#fafafa",
      }}
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px", fontSize: "11px" }}>
        <div><strong>Nombres:</strong> {participante.nombresApellidos || "—"}</div>
        <div><strong>Rol:</strong> {participante.rol || "—"}</div>
        <div><strong>Tipo Doc:</strong> {participante.tipoDocumento || "—"}</div>
        <div><strong>N° Doc:</strong> {participante.numeroDocumento || "—"}</div>
        <div><strong>Fecha Nacimiento:</strong> {fechaNacimiento}</div>
        <div><strong>Edad:</strong> {participante.edadCumplida || "—"}</div>
        <div><strong>Dirección:</strong> {participante.direccionResidencia || "—"}</div>
        <div><strong>Ciudad:</strong> {participante.ciudad || "—"}</div>
        <div><strong>Tel. Fijo:</strong> {participante.telefonoFijo || "—"}</div>
        <div><strong>Tel. Celular:</strong> {participante.telefonoCelular || "—"}</div>
        <div><strong>Tiempo Residencia:</strong> {participante.tiempoResidencia || "—"} años</div>
        <div><strong>Correo:</strong> {participante.correoElectronico || "—"}</div>
      </div>
      {firmasParticipantes[index] && (
        <div style={{ marginTop: "8px", textAlign: "center", borderTop: "1px solid #ddd", paddingTop: "8px" }}>
          <div style={{ fontSize: "9px", marginBottom: "4px", fontWeight: "bold" }}>Firma:</div>
          <img
            src={firmasParticipantes[index]}
            alt={`Firma de ${participante.nombresApellidos || "participante"}`}
            style={{
              maxWidth: "100px",
              maxHeight: "50px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "2px",
              backgroundColor: "#fff",
            }}
          />
        </div>
      )}
    </div>
  );
}
